import React, { useState, useEffect } from "react";
import Header from "../components/shared/Header";
import LeftNavigation from "../components/shared/LeftNavigation";
import Main from "../components/Main";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

function Dashboard() {
  const [title, setTitle] = useState("Dashboard");
  const location = useLocation();
  const authUser = useSelector((state) => state.authUser);

  useEffect(() => {
    if (location.pathname === "/") setTitle("Dashboard");
    else if (location.pathname === "/contacts") setTitle("Contacts");
    else if (location.pathname === "/messages") setTitle("Messages");
    else if (location.pathname === "/voicemail") setTitle("Voicemail");
    else if (location.pathname === "/missed-calls") setTitle("Missed Calls");
    else if (location.pathname === "/wait-time") setTitle("Wait Time");
    else if (location.pathname === "/templates") setTitle("Templates");
    else if (location.pathname === "/reminders") setTitle("Reminders");
    else if (location.pathname === "/profile") setTitle("Profile");
    else if (location.pathname === "/payments") setTitle("Payments");
    else if (location.pathname === "/templates") setTitle("Templates");
    else if (location.pathname === "/preferences") setTitle("Preferences");
    else if (location.pathname === "/blocked-numbers")
      setTitle("Blocked Number");
    else if (location.pathname === "/employees") setTitle("Employees");
    else if (location.pathname === "/voicemail-destination")
      setTitle("Voicemail Destination");
    else if (location.pathname === "/audit-logs") setTitle("Audit Logs");
    else if (location.pathname === "/import-contacts")
      setTitle("Import Contact List");
    else if (location.pathname === "/change-password")
      setTitle("Change Password");
    else if (location.pathname === "/change-fontsize")
      setTitle("Change Fontsize");
  }, [location.pathname]);

  return (
    <div className="row gx-0">
      <LeftNavigation />
      <div className=" col-md-9 col-lg-9 col-sm-12 col-xs-12 main-section">
        <div className="">
          <Header title={title} />
        </div>
        <div>
          {/* {{ outlet }} */}
          <Main />
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
